import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import '../help/OpenSubmissionsHelp.scss';
import { OrderSide } from 'communication/types/order/OrderSide';
import OpenSubmissionsDoughnutChartHelp from 'widgets/openSubmissions/help/OpenSubmissionsDoughnutChartHelp';

interface OpenSubmissionsHelpProps {
    side?: OrderSide;
}

export default function OpenSubmissionsCapsuleHelp(
    props: OpenSubmissionsHelpProps
) {
    const { side } = props;
    return (
        <IconTooltip className="OpenSubmissionsHelp OpenSubmissionsHelpTooltip">
            <div>
                This capsule is a transparency tool as it displays how the algo
                is working by listing where portions of your order are open in
                the market.
            </div>
            <div className="with-diagram">
                <OpenSubmissionsDoughnutChartHelp side={side}>
                    <div className="symbol">SYMBOL</div>
                    <div className="amount">&#35; working</div>
                    <div className="amount">&#35; conditional</div>
                </OpenSubmissionsDoughnutChartHelp>
                <div>
                    Total shares working in the market now.
                    <br />
                    Shares that are conditionally exposed.
                </div>
            </div>
            <div className="with-diagram">
                <OpenSubmissionsDoughnutChartHelp side={side} emphasiseFilled />
                <div>
                    Portion of your order which has been completed, colored by
                    the side of your order.
                </div>
            </div>
            <div className="with-diagram">
                <OpenSubmissionsDoughnutChartHelp
                    side={side}
                    emphasiseExposed
                />
                <div>
                    Portion of your order which is exposed, colored by the venue
                    type.
                </div>
            </div>
            <div>
                The venue types are listed on the right hand side with their
                filled %. Clicking a venue type flips the capsule to show the
                venues, with their order quantity and filled %.
            </div>
        </IconTooltip>
    );
}
